// SARKY: the homepage rail card (snippets/sarky-rail-product-card.liquid) is
// deliberately a single static photo, never a multi-slide gallery -- an
// earlier round put a real slideshow inside it and a swipe gesture on the
// photo was captured by that INNER gallery instead of the rail's own
// horizontal product-to-product carousel, confirmed on a physical device
// (see that file's own doc comment). Colour selection must still be able to
// change WHICH single photo is shown, though.
//
// Listens for the native 'change' event on a swatch radio input (bubbles by
// default, no custom event needed) and, only inside a .sarky-rail-card,
// swaps the card's one <img> to that colour's own real variant photo.
// data-option-media-url (snippets/variant-swatches.liquid) is Shopify's own
// real variant.featured_media URL -- never a filename/ALT-text guess.
document.addEventListener('change', (event) => {
  const input = event.target;
  if (!(input instanceof HTMLInputElement) || input.type !== 'radio') return;

  const card = input.closest('.sarky-rail-card');
  if (!card) return;

  const url = input.dataset.optionMediaUrl;
  if (!url) return;

  const img = card.querySelector('.sarky-rail-card__image');
  if (img instanceof HTMLImageElement) {
    // Clear srcset first: a stale multi-width srcset would otherwise win
    // over the new single src in the browser's own source-selection.
    img.srcset = '';
    img.src = url;
  }
});
